import api from "./axios";

export const getDesigns = () =>
  api.get("/designs");

export const createDesign = (data) =>
  api.post("/designs", data);

export const updateDesign = (id, data) =>
  api.put(`/designs/${id}`, data);

export const deleteDesign = (id) =>
  api.delete(`/designs/${id}`);